import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';
import user from '../../Assets/Login/username.png';
import pass from '../../Assets/Login/pass.png';
import logo from '../../Assets/Login/logo.png';

import axios from 'axios';
import { useAuth } from '../../Context/UserContext/index.tsx';

const LoginPage = () => {
  const navigate = useNavigate();

  const {
    username,
    setUsername,
    password,
    setPassword,
    setErrorMsg,
    errorMsg,
    setCourseId,
    setBatchNo,
    setCanName,
    setSerialNo,
    setSts,
    setNric
  } = useAuth();

  const handleLogin = async () => {
    if (!username || !password) {
      setErrorMsg('Username and password are required.');
      return;
    }

    try {
      const response = await axios.post('https://elearn-api.onrender.com/api/login', {
        username: username,
        Password: password,
      });

      if (response.data && response.data.length > 0) {
        const userData = response.data[0];

        // ✅ Admin login
        if (userData.Type && userData.Type.toLowerCase() === 'admin') {
          localStorage.setItem('adminData', JSON.stringify(userData));
          navigate('/admin');
          return;
        }

        // ✅ Course date validation
        const today = new Date();
        const courseStart = new Date(userData.CourseStartDate);
        const courseEnd = new Date(userData.CourseEndDate);

        if (today < courseStart) {
          setErrorMsg('The course has not started yet.');
          return;
        }

        if (today > courseEnd) {
          setErrorMsg('The course access period has ended.');
          return;
        }

        // ✅ Candidate login
        const courseId = userData.CourseId;
        const batchNo = userData.BatchNo;
        const canName = userData.Name;
        const serialNo = userData.SerialNo;
        const sts = userData.CurrentSts;
        const nric = userData.NricId;

        setCourseId(courseId);
        setBatchNo(batchNo);
        setCanName(canName);
        setSts(sts);
        setSerialNo(serialNo);
        setNric(nric)
        setErrorMsg('');

        localStorage.setItem('userData', JSON.stringify(userData));

        // ✅ Start timer for candidate login only
        localStorage.setItem('loginStartTime', Date.now().toString());

        navigate('/course-info');
      } else {
        setErrorMsg('Invalid credentials. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMsg('Invalid username or password.');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="left-side">
        <img className="logo" src={logo} alt="Logo" />
        <div className="overlay-shape"></div>
      </div>

      <div className="right-side">
        <div className="login-card">
          <h2 className="login-title">LOGIN</h2>

          <div className="input-group">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <img className="icon" src={user} alt="Username" />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img className="icon" src={pass} alt="Password" />
          </div>

          {errorMsg && <p className="error-message">{errorMsg}</p>}

          <button className="login-btn" onClick={handleLogin}>
            Login
          </button>

          <div className="options">
            <a href="#">Forgot Password</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
